export const actionTypes = {
  REQUEST_START: 'PROFILE.CONTACT_INFO.REQUEST_START',
  REQUEST_START_SKIP_LOADING: 'PROFILE.CONTACT_INFO.REQUEST_START.SKIP_LOADING',
  REQUEST_SUCCESS: 'PROFILE.CONTACT_INFO.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'PROFILE.CONTACT_INFO.REQUEST_FAILURE',
  SET: 'PROFILE.CONTACT_INFO.SET',
};

export function startRequest() {
  return {
    type: actionTypes.REQUEST_START,
  };
}

export function startRequestSkipLoading() {
  return {
    type: actionTypes.REQUEST_START_SKIP_LOADING,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}

export function setContactInfo(data) {
  return {
    type: actionTypes.SET,
    payload: data,
  };
}
